import { CloudflareResizeOptions } from '~/components/CloudflareResponsiveImage/CloudflareResizeOptions';

export const AUTOPLAY_DELAY = 5000;

export const HERO_BANNER_IMAGE_PARAMS = {
  mobile: { width: 390, height: 492, fit: 'cover' },
  tablet: { width: 1170, height: 1476, fit: 'cover' },
  desktop: { width: 1920, height: 848, fit: 'cover' },
} as const satisfies Record<string, CloudflareResizeOptions>;
